<template>
    <section class="indBlock titLeft">
        <div class="container">
            <div class="hd clearfix">
                <h3 class="clearfix"><a>推荐人才</a>
                    <el-button class="positionButton" type="primary" plain @click="handlePersonal">更多人才>>
                    </el-button>
                </h3>
            </div>
            <ul class="clearfix personnel">
                <li v-for="(hotBaseInfo, index) in hotBaseInfoList" :key="index">
                    <div @click="showDetail(hotBaseInfo)">
                        <img :src="require('@/pages/frontend/assets/images/'+(hotBaseInfo.gender==MALE?'':'wo')+'man.png')"
                             alt="">
                        <h3>{{hotBaseInfo.username}}</h3>
                        <p>期望职能<span>{{hotBaseInfo.expectPosition}}</span></p>
                        <p>薪资要求<span class="salary">{{rangeFormatter(hotBaseInfo)}}</span></p>
                        <p>技能勋章</p>
                        <p class="tag">
                            <i v-for="(item, index) in hotBaseInfo.skillMedalVoList" :key="index">{{ item.labelName
                                }}</i>
                        </p>
                    </div>
                </li>
            </ul>
        </div>
    </section>
</template>

<script>
    import {findHotBaseInfo} from '@/api/resume'

    const MALE = 0; // 男
    export default {
        name: 'Personnel',
        data() {
            return {
                MALE: MALE,
                hotBaseInfoList: [],
                personnel: [
                    {name: '王先生', sex: 'man', position: '数据分析师', salary: '8-11k / 月'},
                    {name: '王女士', sex: 'woman', position: '数据分析师', salary: '8-11k / 月'},
                    {name: '王先生', sex: 'man', position: '数据分析师', salary: '8-11k / 月'},
                    {name: '王女士', sex: 'woman', position: '数据分析师', salary: '8-11k / 月'},
                    {name: '王先生', sex: 'man', position: '数据分析师', salary: '8-11k / 月'},
                    {name: '王女士', sex: 'woman', position: '数据分析师', salary: '8-11k / 月'},
                    {name: '王先生', sex: 'man', position: '数据分析师', salary: '8-11k / 月'},
                    {name: '王女士', sex: 'woman', position: '数据分析师', salary: '8-11k / 月'},
                ]
            }
        },
        created() {
            this.loadData();
        },
        methods: {
            /** 显示简历详情*/
            showDetail(item) {
                if (item && item.id) {
                    if (process.env.NODE_ENV == "development") {
                        window.open(window.location.origin + "/frontend#/moreResume/detail/" + item.id);
                    } else {
                        window.open(window.location.origin + "/#/moreResume/detail/" + item.id);
                    }
                }
            },
            handlePersonal() {
                if (process.env.NODE_ENV == "development") {
                    window.open(window.location.origin + "/frontend#/moreResume");
                } else {
                    window.open(window.location.origin + "/#/moreResume");
                }
            },
            /** 薪资范围格式化*/
            rangeFormatter(row) {
                return row.willSalaryStart / 1000 + '-' + row.willSalaryEnd / 1000 + 'K•月';
            },
            loadData() {
                findHotBaseInfo().then((res) => {
                    this.hotBaseInfoList = res.data;
                    this.hotBaseInfoList.forEach((item) => {
                        item.expectPosition = item.expectPosition ? JSON.parse(item.expectPosition).join(" • ") : '';
                    });
                })
            }
        }
    };
</script>
